
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Menu = lazy(() => import('../pages/menu/page'));
const Gallery = lazy(() => import('../pages/gallery/page'));
const Access = lazy(() => import('../pages/access/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

import Booking from '../pages/booking/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/menu',
    element: <Menu />,
  },
  {
    path: '/gallery',
    element: <Gallery />,
  },
  {
    path: '/access',
    element: <Access />,
  },
  {
    path: '/booking',
    element: <Booking />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
